// extracted by mini-css-extract-plugin
module.exports = {"clearButton":"ClearButton_clearButton__NPfPO","withLabel":"ClearButton_withLabel__Xd2Ow"};